<template>
<div id="meetingPushing">
  <div class="allSearch">
    <div style="padding: 20px 0" class="newSearch">
      <span :class="postData.ResearchType === '会议调研' ? 'active' : ''" @click="switchThis('会议调研')" class="surSwitch c_p">会议调研</span>
      <span :class="postData.ResearchType === '文章调研' ? 'active' : ''" @click="switchThis('文章调研')" class="surSwitch c_p">文章调研</span>
      <span :class="postData.ResearchType === '分享调研' ? 'active' : ''" @click="switchThis('分享调研')" class="surSwitch c_p">分享调研</span>
    </div>
    <div class="newSearch d_flex">
      <div style="width: auto;white-space: normal">
        <p v-if="postData.ResearchType === '会议调研'">
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="EmsCode" type="text" style="" v-model="postData.MeetingEtmscode">
        </p>
        <p v-if="postData.ResearchType === '文章调研'">
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="文章ID" type="text" style="" v-model="postData.ArticleId">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="调研ID" type="text" style="" v-model="postData.ResearchNo">
        </p>
        <p>
          <input @keyup.enter="getList(1)" class="allInput m_r_10 " placeholder="调研名称" type="text" style="" v-model="postData.ResearchName">
        </p>
        <button class="redButton" @click="getList(1)">搜索</button><button @click="exportSurAll" class="redButton m_l_5"
        >导出调研记录</button><button @click="exportSurAllRead" class="redButton m_l_5">导出阅读未提交记录</button>
      </div>
    </div>
  </div>
  <div style="overflow-x: auto" class="allTablePlace">
    <div>
      <table cellspacing="0" class="allTable">
        <thead>
        <tr>
          <th v-if="postData.ResearchType === '会议调研'">会议EmsCode</th>
          <th v-if="postData.ResearchType === '文章调研'">文章ID</th>
          <th>调研ID</th>
          <th>调研名称</th>
          <th v-if="postData.ResearchType !== '会议调研'">推送人数</th>
          <th>阅读未提交人数</th>
          <th>提交人数</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="index" v-for="(item, index) in myList">
          <td v-if="postData.ResearchType === '会议调研'">{{item.meetingEmscode}}</td>
          <td v-if="postData.ResearchType === '文章调研'" class="t_l">{{item.articleId}}</td>
          <td :title="item.researchNo" class="NoWrap" style="max-width: 200px">{{item.researchNo}}</td>
          <td :title="item.researchName" class="NoWrap" style="max-width: 200px">{{item.researchName}}</td>
          <td class="NoWrap" style="max-width: 200px" v-if="postData.ResearchType !== '会议调研'">{{item.pushCount}}</td>
          <td class="NoWrap" style="max-width: 200px">{{item.readCount}}</td>
          <td class="NoWrap" style="max-width: 200px">{{item.submitCount}}</td>
          <td width="10%">
            <div class="icon more iconfont icongengduo moreOperations">
              <ul>
                <li @click="watchSur(item)">查看调研报告</li>
                <li v-if="item.creatorId===loginInfo.id" @click="exportSur(item)">导出调研报告</li>
              </ul>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <page v-if="totalPage !== 0" v-on:on-getList="getList($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
  </div>
  <model v-if="showModel" :buttonType="1" :title="'查看调研报告'" :maxHeight="'80vh'" :minWidth="'1200px'" v-on:on-cancel="showModel = false" v-on:on-confirm="sendMeeting">
    <div style="width:100%; box-sizing:border-box; padding:10px 40px;max-height: 50vh;overflow-x: auto">
      <div style="border-bottom: 1px solid #eee;margin-top: 10px" v-if="item.subjectType !== '问答' && item.subjectType !== '填空'" :key="index" v-for="(item, index) in reportData" class="surDataList">
        <div>
          <span>题目{{index + 1}}</span>
          <span>{{ item.desc }}</span>
          <span>选择人数</span>
          <span>所占百分比</span>
        </div>
        <div :key="childrenIndex" v-for="(childrenItem, childrenIndex) in item.items">
          <span>{{ childrenItem.itemKey }}</span>
          <span>
            <span style="position: relative;z-index: 1">{{ childrenItem.itemValue }}</span>
            <abbr :style="{'width': childrenItem.sharePercentage}"></abbr>
          </span>
          <span>{{childrenItem.chooseNum}}</span>
          <span>{{childrenItem.sharePercentage}}</span>
        </div>
      </div>
    </div>
    <div class="t_c m_t_10 colorGray">
      * 如需查看问答题、填空题答题详情，请导出调研明细。
    </div>
  </model>
</div>
</template>

<script>
export default {
  name: 'meetingPushing',
  data () {
    return {
      loginInfo: undefined,
      showModel: false,
      baseUrl: process.env.config.baseUrl,
      postData: {
        MeetingEtmscode: '',
        ArticleId: '',
        ResearchNo: '',
        ResearchName: '',
        ResearchType: '会议调研',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      messageList: [],
      totalPage: 1,
      totalCount: 0,
      page: 1,
      meeting: {},
      myList: [
      ],
      reportData: []
    }
  },
  created () {
    this.$axiox.asyncGet('/Login/userinfo').then(p => {
      this.loginInfo = p
      console.log('loginInfo', p)
    })
    this.getList(1)
  },
  methods: {
    exportSurAllRead(){
    let type = 0
      if (this.postData.ResearchType === '会议调研') {
        type = 2
      }
      if (this.postData.ResearchType === '文章调研') {
        type = 1
      }
      var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      let data = {
        MeetingEtmscode: this.postData.MeetingEtmscode,
        ArticleId: this.postData.ArticleId,
        ResearchNo: this.postData.ResearchNo,
        ResearchName: this.postData.ResearchName,
        ResearchType: this.postData.ResearchType,
        CreatorId:this.loginInfo.id
      }
      let url = this.$commonJs.returnQuery(this.baseUrl + '/api/Research/readrecord/export/all', data)
      xmlResquest.open('GET', url, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = '调研阅读未提交记录报告.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
    },
    exportSurAll () {
      let type = 0
      if (this.postData.ResearchType === '会议调研') {
        type = 2
      }
      if (this.postData.ResearchType === '文章调研') {
        type = 1
      }
      var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      let data = {
        MeetingEtmscode: this.postData.MeetingEtmscode,
        ArticleId: this.postData.ArticleId,
        ResearchNo: this.postData.ResearchNo,
        ResearchName: this.postData.ResearchName,
        ResearchType: this.postData.ResearchType,
        CreatorId:this.loginInfo.id
      }
      let url = this.$commonJs.returnQuery(this.baseUrl + '/api/Research/records/export/all', data)
      xmlResquest.open('GET', url, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = '调研提交记录报告.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
    },
    exportSur (item) {
      let type = 0
      if (this.postData.ResearchType === '会议调研') {
        type = 2
      }
      if (this.postData.ResearchType === '文章调研') {
        type = 1
      }
      var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      xmlResquest.open('GET', this.baseUrl + '/api/Research/records/export?id=' + item.researchId + '&type=' + type + '&meetingEtmscode=' + (item.meetingEmscode || '') + '&articleId=' + (item.articleId || 0), true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = '调研报告.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
      // this.$axiox.get('/api/Group/' + id + '/export?groupName=' + name).then(msg => {
      // })
    },
    watchSur (item) {
      let type = 0
      if (this.postData.ResearchType === '会议调研') {
        type = 2
      }
      if (this.postData.ResearchType === '文章调研') {
        type = 1
      }
      this.$axiox.get('/api/Research/records/report?id=' + item.researchId + '&type=' + type + '&meetingEtmscode=' + (item.meetingEmscode || '') + '&articleId=' + (item.articleId || 0)).then(p => {
        this.reportData = p.subjects
        this.showModel = true
      })
    },
    sendMeeting () {
      this.$refs.meetModel.sendMsg()
    },
    getDetail (item) {
      this.meeting = item
      this.showModel = true
    },
    switchThis (type) {
      this.postData.ResearchType = type
      this.postData.ArticleId = ''
      this.postData.MeetingEtmscode = ''
      this.getList(1)
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/Research/records/list', data)
      this.$axiox.getList(url).then(msg => {
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/surveryManager/surveryData.vue